<label *ngIf="label"
  [class.warn]="formControl && (formControl.dirty || formControl.touched) && formControl.errors?.required">
  {{ label }}
  <span *ngIf="required" class="mat-form-field-required-marker">*</span>
</label>

<div class="time-input-wrapper">
  <input [ngModel]="hour|number:'2.0-0'" class="hours" maxlength="2" [min]="minHour" [max]="maxHour"
    (keypress)="onKeypress($event)" (keydown)="onKeydown($event)" [disabled]="disabled" (blur)="onBlur($event)">

  <span class="colon-separator">:</span>

  <input [ngModel]="minute|number:'2.0-0'" class="minutes" maxlength="2" [min]="minMinute" [max]="maxMinute"
    (keypress)="onKeypress($event)" (keydown)="onKeydown($event)" [disabled]="disabled" (blur)="onBlur($event)">

  <ng-container *ngIf="picker">
    <input type="hidden" [ngModel]="value" [ngxTimepicker]="timePicker" [disableClick]="true" readonly [format]="24"
      [min]="min" [max]="max" (ngModelChange)="writeValue($event); triggerChange()">
    <ngx-material-timepicker-toggle [for]="timePicker" [disabled]="disabled"></ngx-material-timepicker-toggle>
    <ngx-material-timepicker #timePicker [minutesGap]="minuteGap > 1 ? minuteGap : null" [hoursOnly]="minuteGap === 60"
      [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn">
    </ngx-material-timepicker>

    <ng-template #cancelBtn>
      <button mat-raised-button style="margin-right: 10px;" color="warn" type="button">Annuler</button>
    </ng-template>
    <ng-template #confirmBtn>
      <button mat-raised-button style="margin-right: 10px;" color="primary" type="button">Valider</button>
    </ng-template>
  </ng-container>
</div>
